module.exports = __webpack_public_path__ + "media/sunriseapartment.db442a51.mp4";